import {
  HomeIcon,
  ExploreIcon,
  SearchIcon,
  BasketIcon,
  AccountIcon,
  LanguageIcon,
} from '../../icons/NavIcons';
import {
  Badge,
  BottomItems,
  IconWrapper,
  NavItem,
  NavLabel,
  Rail,
  TopItems,
} from './SideNav.styles';
import type { SideNavItem, SideNavProps } from './SideNav.types';

const iconMap = {
  home: HomeIcon,
  explore: ExploreIcon,
  search: SearchIcon,
  basket: BasketIcon,
  account: AccountIcon,
  language: LanguageIcon,
} as const;

function renderNavItem(item: SideNavItem) {
  const IconComponent = iconMap[item.icon];
  return (
    <NavItem
      key={item.id}
      $active={item.active}
      onClick={item.onClick}
      type="button"
      aria-label={item.label}
    >
      <IconWrapper>
        <IconComponent size={20} />
        {item.badge != null && item.badge > 0 && <Badge>{item.badge}</Badge>}
      </IconWrapper>
      <NavLabel>{item.label}</NavLabel>
    </NavItem>
  );
}

export function SideNav({ items, bottomItems, navigationLabel = 'Main navigation' }: SideNavProps) {
  return (
    <Rail aria-label={navigationLabel}>
      <TopItems>{items.map(renderNavItem)}</TopItems>
      {bottomItems && bottomItems.length > 0 && (
        <BottomItems>{bottomItems.map(renderNavItem)}</BottomItems>
      )}
    </Rail>
  );
}
